var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({class:_vm.customClass,style:([{ width: `${_vm.width ? _vm.width + 'px' : ''}` }, _vm.inlineStyle]),attrs:{"outlined":_vm.outlined,"color":_vm.color,"text-color":_vm.textColor,"small":_vm.small,"x-small":_vm.xSmall,"label":""}},'v-chip',_vm.vBindAttrs,false),_vm.vOn),[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }